import { Modal, ModalBody, ModalHeader, ModalTitle, } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const IFRStoryV3Modal = ({ onClose, story }) => {
    return (React.createElement(Modal, { closeButton: true, onClose: onClose, show: true, size: "large" },
        React.createElement(ModalHeader, null,
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(ModalTitle, null, story.headline),
                story.date.toLocaleTimeString())),
        React.createElement(ModalBody, null,
            React.createElement("div", { dangerouslySetInnerHTML: { __html: story.abstractText } }))));
};
export default IFRStoryV3Modal;
